<!--
  ~ Copyright (c) Worldline 2022.
  -->

<!DOCTYPE html>

<section>
    <h3 id="certificate-approval-title">{{ 'certificate.approval.consent.header' | translate }} {{ firstName }} {{ lastName }}</h3>
    <form class="content" novalidate>
        <div class="certificate-approval-consent-text">
            <p>
                <span *ngIf="!multipledocuments" id="text-approval-single"
                      [innerHTML]="'certificate.approval.consent.text.single-document' | translate "></span>
                <span *ngIf="multipledocuments" id="text-approval-multiple"
                      [innerHTML]="'certificate.approval.consent.text.multiple-documents' | translate "></span>
                <span>
                    <a id="certification-link" target="_blank"
                       href="{{ 'certification.url' | translate }}"> {{ 'certificate.approval.consent.link' | translate }}</a>
                </span>
            </p>
        </div>
        <fieldset class="k-check">
            <legend id="certificate-approval-consent-title">{{ 'certificate.approval.title' | translate }}</legend>
            <div class="certificate-approval-content">
                <ul>
                    <li>
                        <input
                                type="checkbox"
                                [id]="'consent-gcs'"
                                [required]="true"
                                [(ngModel)]="certificateValidation.gcs" [ngModelOptions]="{standalone: true}"/>
                        <label [for]="'consent-gcs'">
                            <embedded-link
                                    [action]="getOpenGcs()"
                                    [data]="'certificate.approval.gcs' | translate"
                                    [id]="'label-consent-gcs'">

                            </embedded-link>
                            *
                        </label>
                    </li>
                    <li>
                        <input
                                type="checkbox"
                                [id]="'consent-certificate-information'"
                                [required]="true"
                                [(ngModel)]="certificateValidation.certificate" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateCertificateValidation()"/>
                        <label [for]="'consent-certificate-information'">
                            <span [id]="'label-consent-certificate-information'">{{'certificate.approval.certificate' | translate}} *</span>
                        </label>
                    </li>
                </ul>
                <div class="certificate-approval-values">
                    <dl>
                        <dt>{{ 'certificate.approval.last-name' | translate }}</dt>
                        <dd><strong id="certificate-issued-to-last-name">{{lastName}}</strong></dd>
                        <dt>{{ 'certificate.approval.first-name' | translate }}</dt>
                        <dd><strong id="certificate-issued-to-first-name">{{firstName}}</strong></dd>
                    </dl>
                </div>
            </div>
        </fieldset>
    </form>
</section>
